import React from "react";
import expertenauftraege from "../data/expertenauftraege-gutachten_2025.json";
import { List, Caption } from "../components";
import Page from "./Page";
import "./ExpertenauftraegePage.css";

export default class ExpertenauftraegePage extends React.Component {
  render() {
    return (
      <Page title="Expertenaufträge, Untersuchungen und Gutachten">
        <p>
          Aufgeführt sind nur Aufträge öffentlicher Institutionen oder von
          Privatpersonen, soweit der Auftraggeber oder die Auftraggeberin die
          entsprechenden Berichte und Gutachten publiziert oder in anderer Weise
          öffentlich darauf hingewiesen hat.
        </p>
        <p>Die Auswahl beschränkt sich auf die letzten Jahre.</p>
        <Caption className="expertenauftraege-page__caption">Auswahl</Caption>
        <List elements={expertenauftraege} />
      </Page>
    );
  }
}
